import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  ASSESSMENT_CATEGORY_LIST,
  ASSESSMENT_CATEGORY_ADD,
  ASSESSMENT_CATEGORY_DETAIL,
  ASSESSMENT_CATEGORY_UPDATE
} from '../../actions';

import {
  AssessmentCategoryListSuccess,
  AssessmentCategoryListError,
  AssessmentCategoryAddSuccess,
  AssessmentCategoryAddError,
  AssessmentCategoryDetailSuccess,
  AssessmentCategoryDetailError,
  AssessmentCategoryUpdateSuccess,
  AssessmentCategoryUpdateError
} from '../../actions';
 
export function* watchAssessmentCategoryList() {
  yield takeEvery(ASSESSMENT_CATEGORY_LIST, onAssessmentCategoryList);
}

export function* watchAssessmentCategoryAdd() {
  yield takeEvery(ASSESSMENT_CATEGORY_ADD, onAssessmentCategoryAdd);
}

export function* watchAssessmentCategoryDetail() {
  yield takeEvery(ASSESSMENT_CATEGORY_DETAIL, onAssessmentCategoryDetail);
}

export function* watchAssessmentCategoryUpdate() {
  yield takeEvery(ASSESSMENT_CATEGORY_UPDATE, onAssessmentCategoryUpdate);
}

const onAssessmentCategoryListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/assessment_category/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAssessmentCategoryUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/assessment_category/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAssessmentCategoryAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/assessment_category/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAssessmentCategoryDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/assessment_category/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onAssessmentCategoryList(data) {
  try {
    const response = yield call(onAssessmentCategoryListAsync, data.payload);
    yield put(AssessmentCategoryListSuccess(response.data));
  } catch (error) {
    yield put(AssessmentCategoryListError(error));
  }
}

function* onAssessmentCategoryAdd(data) {
  try {
      const response = yield call(onAssessmentCategoryAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AssessmentCategoryAddSuccess(response.data));
  } catch (error) {
      yield put(AssessmentCategoryAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onAssessmentCategoryDetail(data) {
  try {
    const response = yield call(onAssessmentCategoryDetailAsync, data.payload);
    yield put(AssessmentCategoryDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AssessmentCategoryDetailError(error));
  }
}

function* onAssessmentCategoryUpdate(data) {
  try {
      const response = yield call(onAssessmentCategoryUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AssessmentCategoryUpdateSuccess(response.data));
  } catch (error) {
      yield put(AssessmentCategoryUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchAssessmentCategoryList),
    fork(watchAssessmentCategoryAdd),
    fork(watchAssessmentCategoryDetail),
    fork(watchAssessmentCategoryUpdate),
  ]);
} 